import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { CuratorStudentState, ListResponse, CourseState } from '../types'
import { update } from 'lodash'

interface fetchAllStudentsParams {
    filter: string
    size: number
    page: number
    courseId: number
    groupId?: number
    monthNumber?: number
    weekNumber?: number
    sortColumn?: number
    sortDir?: number
    videoFilter?: number
    testFilter?: number
}

export interface CuratorGroupState {
    id: number
    title: string
    courseSubjectId?: number
}

// Пән басшы: менторы его предметов, по строке на пару ментор-группа
export interface HeadWeakTopicState {
    topicId: number
    titleKz: string
    titleRu: string
    attempted: number
    failed: number
}

export interface HeadMentorGroupState {
    mentorId: number
    firstName: string
    lastName: string
    groupId: number
    groupTitle: string
    courseId: number
}

export const curatorStudentsApiSlice = createApi({
    reducerPath: 'curatorApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Student', 'Course', 'Group'],
    endpoints: (build) => ({
        fetchAllStudents: build.query<
            ListResponse<CuratorStudentState>,
            fetchAllStudentsParams
        >({
            query: (params) => ({
                url: `curator/students`,
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Student' as const,
                            id,
                        })),
                        { type: 'Student', id: 'LIST' },
                    ]
                    : [{ type: 'Student', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<CuratorStudentState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),
        fetchCuratorCourses: build.query<ListResponse<CourseState>, void>({
            query: () => ({
                url: `curator/courses`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Course' as const,
                            id,
                        })),
                        { type: 'Course', id: 'LIST' },
                    ]
                    : [{ type: 'Course', id: 'LIST' }],
        }),
        fetchCuratorGroups: build.query<CuratorGroupState[], number>({
            query: (courseId) => ({
                url: `curator/groups`,
                params: { courseId },
            }),
            transformResponse: (response: { data: CuratorGroupState[] }) => response.data,
            providesTags: [{ type: 'Group', id: 'LIST' }],
        }),
        fetchHeadMentors: build.query<HeadMentorGroupState[], void>({
            query: () => ({
                url: `subject-head/mentors`,
            }),
            transformResponse: (response: { data: HeadMentorGroupState[] }) => response.data,
        }),
        fetchWeakTopics: build.query<
            HeadWeakTopicState[],
            { mentorId?: number; courseId?: number; monthNumber?: number; weekNumber?: number; limit?: number }
        >({
            query: (params) => ({
                url: `subject-head/weak-topics`,
                params,
            }),
            transformResponse: (response: { data: HeadWeakTopicState[] }) => response.data,
        }),
        fetchStudentProgress: build.query<CuratorStudentState, { userCourseEnrollId: number }>({
            query: ({ userCourseEnrollId }) => ({
                url: `curator/students/${userCourseEnrollId}`,
            }),
            transformResponse: (response: {
                data: CuratorStudentState
            }) => response.data,
            providesTags: (result, error, { userCourseEnrollId }) => [
                { type: 'Student' as const, id: userCourseEnrollId },
            ],
        }),

        updateStudentPerformance: build.mutation<void, { userCourseEnrollId: number, performanceLevel: string }>({
            query: ({ userCourseEnrollId, performanceLevel }) => ({
                url: `curator/students/performance`,
                method: 'POST',
                body: { userCourseEnrollId, performanceLevel },
            }),
            invalidatesTags: (result, error, { userCourseEnrollId }) => [
                { type: 'Student', id: 'LIST' },
                { type: 'Student', id: userCourseEnrollId },
            ],
        }),

    }),
})
